import { config } from '@fortawesome/fontawesome-svg-core'
import { Header } from '@repo/complib/Header'
import { NavigationProvider } from './Navigation/NavigationContext'
import { NextIntlClientProvider } from 'next-intl'
import { SessionProvider } from 'next-auth/react'

const HeaderWidget = () => {
  config.autoAddCss = false
  const locale = import.meta.env.LOCALE ?? ''
  const messages = import.meta.env.I18N_MESSAGES ?? {}

  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      timeZone='Europe/Berlin'
    >
      <SessionProvider>
        <NavigationProvider
          options={{
            disableProgressScrollbar: true,
            disableOutsideInteraction: true,
          }}
        >
          <Header />
        </NavigationProvider>
      </SessionProvider>
    </NextIntlClientProvider>
  )
}

export default HeaderWidget
